// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2R8m6","label":"Radio_label__7iJmQ","checkMark":"Radio_checkMark__1Aq3j","disabled":"Radio_disabled__3a2qM"};